import styled from "styled-components";
import { fonts } from "./../../../../styles/fonts";

const Nav = styled.nav`
  width: 100%;
  background-color: transparent;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 100;
  padding: 15px 0;
  height: fit-content;
`;

const NavContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin: 0 auto;
  padding: 15px 20px;
  
  @media screen and (min-width: 769px) {
    position: relative;
    width: fit-content;
    border-radius: 100px;
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    border: 1px solid rgba(255, 255, 255, 0.3);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1),
      inset 0 1px 0 rgba(255, 255, 255, 0.05),
      inset 0 -1px 0 rgba(255, 255, 255, 0.01),
      inset 0 0 6px 3px rgba(255, 255, 255, 0.03);
    overflow: hidden;
  }

  @media screen and (max-width: 768px) {
    justify-content: space-between;
    border: none;
    position: relative;
    background: transparent;
    backdrop-filter: blur(0px);
    box-shadow: none;
    top: 15px;
    width: calc(100% - 30px);
  }
`;

const NavLinkContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 64px;
  font-family: ${fonts["source-code"]};
  font-size: 14px;
  font-weight: 600;
  text-transform: lowercase;
`;

export { Nav, NavContainer, NavLinkContainer };
